<template>
  <div id="barrierfree_container">
    <div id="barrierfree" src="/accessiblereading/" style="display: none"></div>
    <div v-if="bannerType !== 'oneThing'" class="bannerTab">
      <div class="title" style="position: relative;">
        <span style="margin-top: -10px;">{{ bannerType === 'legalperson' ? '法人服务' : '个人服务' }}</span>
        <span class="GlobalHeadBox">

          <GlobalHead style="display: inline-block;position: absolute; top: -5px;" @updateData="updateData" @updateGroup="updateGroup" />
        </span>
      </div>

      <div class="tabs">
        <div
          class="tab"
          :class="[labelType === 'hot' ? 'bannerActive' : 'bannerInactive']"
          @click="changeLabelType('hot')"
        >
          热门服务
        </div>
        <div
          class="tab"
          :class="[labelType === 'theme' ? 'bannerActive' : 'bannerInactive']"
          @click="changeLabelType('theme')"
        >
          主题服务
        </div>
        <div
          class="tab"
          :class="[labelType === 'department' ? 'bannerActive' : 'bannerInactive']"
          @click="changeLabelType('department')"
        >
          部门服务
        </div>
        <div
          class="tab"
          :class="[labelType === 'group' ? 'bannerActive' : 'bannerInactive']"
          @click="changeLabelType('group')"
        >
          群体服务
        </div>
      </div>
    </div>
    <!-- 一件事个人法人切换 -->
    <div v-if="bannerType === 'oneThing'" class="topBanner">
      <a-row type="flex" justify="center" align="bottom" style="height: 200px">
        <a-col flex="320px">
          <div
            :class="personOneThing ? 'one-thing-div-active' : 'one-thing-div'"
            @click="changeOneThing('personal')"
          >
            <span :class="personOneThing ? 'one-thing-text-active' : 'one-thing-text'">
              个人一件事
            </span>
          </div>
        </a-col>
        <a-col flex="320px">
          <div
            :class="!personOneThing ? 'one-thing-div-active' : 'one-thing-div'"
            @click="changeOneThing('legalperson')"
          >
            <span :class="!personOneThing ? 'one-thing-text-active' : 'one-thing-text'">
              法人一件事
            </span>
          </div>
        </a-col>
      </a-row>
    </div>
    <div v-if="bannerType === 'oneThing'" class="wrapper">
      <!-- 轮播图 -->
      <!-- <a-carousel v-if="middleData && middleData.length > 0 && middleData[0].length > 0 && (bannerType === 'personal' || bannerType === 'legalperson')">
        <div class="swiperBoxWrap" v-for="(li, index) in middleData" :key="index" >
          <div class="swiperBox" @click="golocalFeature(item.iid,item.subjectName)" v-for="(item) in middleData[index]" :key="item.iid">
            <img :src="item.iconUrl" alt="" v-if="item.iconUrl">
            <div style="width: 80px;height: 80px;line-height: 80px;text-align: center;border: 1px solid #ececec" v-else>暂无图标</div>
            <span class="swiperContet">
              <a-tooltip placement="top" >
                <template slot="title">
                  {{ item.subjectName }}
                </template>
                {{ item.subjectName }}
              </a-tooltip>
            </span>
          </div>
        </div>
      </a-carousel> -->
      <div style="overflow: hidden; margin-bottom: 20px">
        <!-- 左 -->
        <div class="leftSider">
          <LeftSider
            @getselectDis="getselectDis"
            ref="leftSider"
            v-if="bannerType === 'personal' || bannerType === 'legalperson'"
          />
          <LeftSiderOneThing
            ref="leftSiderOneThing"
            @load="loadmenuData"
            @reLoadRight="reLoadRight"
            v-else
          />
        </div>
        <!-- 单事项右侧 -->
        <div class="rightSide" v-if="bannerType === 'personal' || bannerType === 'legalperson'">
          <div class="rightSideTop">
            <div class="liRow">
              <span class="title">适用群体</span>
              <div class="liContent">
                <span class="liContentTag" v-for="item in mockData" :key="item.iid">
                  <span
                    :class="['tagCont', item.isActive ? 'active' : '']"
                    @click="selectLi(item, 'type1')"
                  >
                    <div
                      style="
                        display: inline-block;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        max-width: 90%;
                        white-space: nowrap;
                      "
                      :title="item.subjectName"
                    >
                      {{ item.subjectName }}
                    </div>
                  </span>
                </span>
                <a
                  v-if="mockData.length > 9 && !moreVis1"
                  @click="moreClick('type1', true)"
                  class="tagContTemp"
                >
                  展开
                </a>
                <a
                  v-if="mockData.length > 9 && moreVis1"
                  @click="moreClick('type1', false)"
                  class="tagContTemp"
                >
                  收起
                </a>
              </div>
            </div>
            <div class="liRow">
              <span class="title">事项主题</span>
              <div class="liContent">
                <span class="liContentTag" v-for="(item, index) in mockData2" :key="item.iid">
                  <span
                    v-if="index < 9 || (index >= 9 && moreVis2)"
                    :class="['tagCont', item.isActive ? 'active' : '']"
                    @click="selectLi(item, 'type2')"
                  >
                    <div
                      style="
                        display: inline-block;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        max-width: 90%;
                        white-space: nowrap;
                      "
                      :title="item.subjectName"
                    >
                      {{ item.subjectName }}
                    </div>
                  </span>
                </span>
                <a
                  v-if="mockData2.length > 9 && !moreVis2"
                  @click="moreClick('type2', true)"
                  class="tagContTemp"
                >
                  展开
                </a>
                <a
                  v-if="mockData2.length > 9 && moreVis2"
                  @click="moreClick('type2', false)"
                  class="tagContTemp"
                >
                  收起
                </a>
              </div>
            </div>
            <div class="liRow">
              <span class="title">事项类型</span>
              <div class="liContent">
                <span class="liContentTag" v-for="(item, index) in mockData3" :key="item.iid">
                  <span
                    v-if="index < 9 || (index >= 9 && moreVis3)"
                    :class="['tagCont', item.isActive ? 'active' : '']"
                    @click="selectLi(item, 'type3')"
                  >
                    <div
                      style="
                        display: inline-block;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        max-width: 90%;
                        white-space: nowrap;
                      "
                      :title="item.subjectName"
                    >
                      {{ item.subjectName }}
                    </div>
                  </span>
                </span>
                <a
                  v-if="mockData3.length > 9 && !moreVis3"
                  @click="moreClick('type3', true)"
                  class="tagContTemp"
                >
                  展开
                </a>
                <a
                  v-if="mockData3.length > 9 && moreVis3"
                  @click="moreClick('type3', false)"
                  class="tagContTemp"
                >
                  收起
                </a>
              </div>
            </div>
            <div class="allselect">
              <span
                class="title"
                v-if="selectData1.length > 0 || selectData2.length > 0 || selectData3.length > 0"
              >
                已选
              </span>
              <a-tag
                style="margin-bottom: 10px"
                color="blue"
                closable
                @close="tagClose('type1', item1)"
                v-for="item1 in selectData1"
                :key="item1.iid + Math.random()"
              >
                {{ item1.subjectName }}
              </a-tag>
              <a-tag
                style="margin-bottom: 10px"
                color="blue"
                closable
                @close="tagClose('type2', item2)"
                v-for="item2 in selectData2"
                :key="item2.iid + Math.random()"
              >
                {{ item2.subjectName }}
              </a-tag>
              <a-tag
                style="margin-bottom: 10px"
                color="blue"
                closable
                @close="tagClose('type3', item3)"
                v-for="item3 in selectData3"
                :key="item3.iid + Math.random()"
              >
                {{ item3.subjectName }}
              </a-tag>
              <span
                v-if="selectData1.length > 0 || selectData2.length > 0 || selectData3.length > 0"
              >
                <a-icon
                  style="color: #1777ff; font-size: 16px; margin-right: 5px"
                  :component="IconDelete"
                ></a-icon>
                <a @click="allDelete">全部删除</a>
              </span>
            </div>
          </div>
          <div class="rightSideBot">
            <div class="header">
              <span style="font-size: 14px; color: #999999; float: left">
                {{ itemTotal }}件事项
              </span>
              <span style="float: right" v-if="false">
                <a-checkbox :checked="queryParams.appointCheck" @change="appointChange">
                  可预约办理
                </a-checkbox>
                <a-checkbox :checked="queryParams.onLineCheck" @change="onLineChange">
                  可在线办理
                </a-checkbox>
                <span style="margin-left: 5px">
                  默认排序
                  <a-icon :component="IconCaretDown"></a-icon>
                </span>
              </span>
            </div>
            <div class="contentList">
              <div class="liStyle" v-for="(item, index) in matterList" :key="index">
                <div class="liLeft">
                  <div
                    class="title"
                    :title="item.itemName"
                    @click="toPublic(item.iid, item.guidePcSite)"
                    style="cursor: pointer"
                  >
                    {{ item.itemName }}
                  </div>
                  <div style="margin-top: 2px">
                    <a-tag v-for="(tagLi, indexLi) in item.tagList" :key="indexLi" color="orange">
                      {{ tagLi.name }}
                    </a-tag>
                    <span style="font-size: 14px; margin-left: 5px; color: #666666">
                      {{ item.deptName }}
                    </span>
                  </div>
                </div>
                <div class="rightLeft">
                  <!-- <span class="btnStyle" @click="videoHelp(item.itemName)">视频帮办</span> -->
                  <span
                    class="btnStyle btn"
                    v-if="item.smartGuidance === 'on'"
                    @click="toPublic(item.iid, item.guidePcSite, true)"
                  >
                    智能导办
                  </span>
                  <span
                    class="btnStyle"
                    v-if="item.taskOnline == 'yes'"
                    @click="toGuide(item.iid, item.itemName, 'item', item.taskPcSite)"
                  >
                    在线办理
                  </span>
                  <span class="btnFalseStyle" v-else>在线办理</span>
                  <span class="btnStyle" v-if="false">预约办理</span>
                </div>
              </div>
              <div style="text-align: center; margin: 20px 0">
                <a-pagination
                  :total="pagination.total"
                  :show-total="(total, range) => `共有${pagination.total}条`"
                  showQuickJumper
                  :current="pagination.current"
                  @change="pageChange"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- 一件事右侧 -->
        <div class="rightSideOneThing" ref="rightSideOneThing" v-show="oneThingCount > 0" v-else>
          <div class="right-title">{{ districtName }}共{{ oneThingCount }}件事</div>
          <div>
            <div :key="item.iid" v-for="item in oneThingTheme">
              <div
                v-if="
                  oneThingList != null &&
                    oneThingList[item.iid] != null &&
                    oneThingList[item.iid].length > 0
                "
              >
                <div class="subject-title">
                  {{ item.subjectName }}
                  <a :name="item.iid"></a>
                </div>
                <div
                  style="cursor: pointer"
                  class="card-content"
                  @mouseover="mouseOver"
                  @mouseleave="mouseLeave"
                  v-for="iit in oneThingList[item.iid]"
                  :key="iit.iid"
                >
                  <div
                    class="card-content-left"
                    @click="toOneThingGuide(iit.oneThingId, item.subjectName, iit)"
                  >
                    <span class="card-content-left-title">{{ iit.oneThingName }}</span>
                    <!-- 小于4个 -->
                    <div
                      style="margin-top: 8px"
                      v-if="iit.itemNameList != null && iit.itemNameList.length <= 4"
                    >
                      <div
                        class="card-content-left-content"
                        v-for="(it, index) in iit.itemNameList"
                        :key="index"
                      >
                        <div>
                          <span style="margin-right: 11px; font-size: 18px; color: #333333">·</span>
                          <ellipsis :length="44" tooltip>{{ iit.itemNameList[index] }}</ellipsis>
                        </div>
                      </div>
                    </div>
                    <!-- 大于4个 -->
                    <div
                      style="margin-top: 8px"
                      v-if="iit.itemNameList != null && iit.itemNameList.length > 4"
                    >
                      <div class="card-content-left-content">
                        <div>
                          <span style="margin-right: 11px; font-size: 18px; color: #333333">·</span>
                          <span>{{ iit.itemNameList[0] }}</span>
                        </div>
                      </div>
                      <div class="card-content-left-content">
                        <div>
                          <span style="margin-right: 11px; font-size: 18px; color: #333333">·</span>
                          <span>{{ iit.itemNameList[1] }}</span>
                        </div>
                      </div>
                      <div class="card-content-left-content">
                        <div>
                          <span style="margin-right: 11px; font-size: 18px; color: #333333">·</span>
                          <span>{{ iit.itemNameList[2] }}</span>
                        </div>
                      </div>
                      <div class="card-content-left-link" v-if="iit.itemNameList.length > 4">
                        前往办事指南查看全部>
                      </div>
                    </div>
                  </div>
                  <!-- 与单事项对比 -->
                  <div
                    class="card-content-right"
                    style="text-align: right; height: 100%; margin-left: 19px"
                  >
                    <a-row type="flex" justify="start" style="text-align: center; height: 31px">
                      <a-col flex="114px"></a-col>
                      <a-col flex="80px">
                        <span class="card-content-right-old">过去办</span>
                      </a-col>
                      <a-col flex="46px"></a-col>
                      <a-col flex="106px">
                        <span class="card-content-right-now">现在办</span>
                      </a-col>
                    </a-row>
                    <!--  -->
                    <a-row type="flex" justify="center" style="text-align: center; height: 44px">
                      <a-col flex="114px">
                        <a-icon
                          type="clock-circle"
                          style="margin-right: 8px; margin-left: -3px"
                          :style="{ fontSize: '16px' }"
                        />
                        <span class="card-content-right-text">办理时间</span>
                      </a-col>
                      <a-col flex="80px">
                        <div class="old-div">
                          <span class="old-div-text">
                            <s>{{ transferredTime(iit.handleDays).item }}天</s>
                          </span>
                        </div>
                      </a-col>
                      <a-col flex="56px">
                        <img src="./rightArrow.png" style="width: 24px" alt="" />
                      </a-col>
                      <a-col flex="106px">
                        <div class="new-div">
                          <span class="new-div-text">
                            {{ transferredTime(iit.handleDays).onething }}天
                          </span>
                        </div>
                      </a-col>
                    </a-row>
                    <a-row type="flex" justify="start" style="text-align: center; height: 44px">
                      <a-col flex="119px">
                        <a-icon
                          :component="IconRunTime"
                          style="margin-right: 8px; margin-left: -6px"
                          :style="{ fontSize: '16px' }"
                        />
                        <span class="card-content-right-text">跑动次数</span>
                      </a-col>
                      <a-col flex="80px">
                        <div class="old-div">
                          <span class="old-div-text">
                            <s>{{ transferredTime(iit.runTimes).item }}次</s>
                          </span>
                        </div>
                      </a-col>
                      <a-col flex="51px">
                        <img src="./rightArrow.png" style="width: 24px" alt="" />
                      </a-col>
                      <a-col flex="80px">
                        <div class="new-div">
                          <span class="new-div-text">
                            {{ transferredTime(iit.runTimes).onething }}次
                          </span>
                        </div>
                      </a-col>
                    </a-row>
                    <a-row type="flex" justify="start" style="text-align: center; height: 44px">
                      <a-col flex="119px">
                        <a-icon
                          :component="IconFileText"
                          style="margin-right: 8px; margin-left: -6px"
                          :style="{ fontSize: '16px' }"
                        />
                        <span class="card-content-right-text">递交材料</span>
                      </a-col>
                      <a-col flex="80px">
                        <div class="old-div">
                          <span class="old-div-text">
                            <s>{{ transferredTime(iit.materialCount).item }}份</s>
                          </span>
                        </div>
                      </a-col>
                      <a-col flex="51px">
                        <img src="./rightArrow.png" style="width: 24px" alt="" />
                      </a-col>
                      <a-col flex="80px">
                        <div class="new-div">
                          <span class="new-div-text">
                            {{ transferredTime(iit.materialCount).onething }}份
                          </span>
                        </div>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="card-content-right-action">
                    <div
                      class="btnStyle-btn"
                      @click="toGuide(iit.oneThingId, iit.oneThingName, 'onething')"
                      @mouseover="mouseOverBtn"
                      @mouseleave="mouseLeaveBtn"
                    >
                      在线办理
                    </div>
                    <div
                      class="btn"
                      v-if="iit.smartGuidance === 'on'"
                      @click="toOneThingGuide(iit.oneThingId, item.subjectName, iit, true)"
                    >
                      智能导办
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="oneThingCount == 0" style="line-height: 400px; text-align: center">
          <img src="./emptyList.svg" style="width: 240px" alt="" />
        </div>
        <a-modal :visible="visible" title="提示" @ok="handleOk" @cancel="handleCancel">
          <a-row style="padding: 8px">
            <a-col :span="2" style="margin-right: 8px">
              <a-icon type="exclamation-circle" style="color: #1890ff; font-size: 22px" />
            </a-col>
            <a-col :span="20">
              <p class="info">您当前尚未登录，是否登录？</p>
            </a-col>
          </a-row>
        </a-modal>
        <a-modal v-model="draftVisible" :footer="null" :closable="false" width="420px">
          <a-row style="padding: 8px">
            <a-col :span="2" style="margin-right: 8px">
              <a-icon type="exclamation-circle" style="color: #1890ff; font-size: 22px" />
            </a-col>
            <a-col :span="20">
              <p class="info">
                您于{{ handling.ctime | timeTransfer }}保存了该事项的草稿，要继续编辑吗？
              </p>
            </a-col>
          </a-row>
          <div style="text-align: right">
            <a-button
              key="cancel"
              type="defult"
              style="margin-right: 5px"
              @click="routingHop(itemId)"
            >
              重新填报
            </a-button>
            <a-button key="submit" type="primary" @click="refill">继续编辑</a-button>
          </div>
        </a-modal>
      </div>
    </div>
    <Label ref="label" v-show="labelType === 'hot'" :districtId="districtId"></Label>
    <SingleEventServices
      ref="singleEventServices"
      :labelType="labelType"
      :bannerType="bannerType"
      :districtId="districtId"
      v-show="labelType !== 'hot'"
      v-if="this.$route.query.bannerType !== 'oneThing'" />
    <!-- <router-view :key="routerKey" /> -->
    <!-- <GlobalFoot /> -->
  </div>
</template>

<script>
import { axios } from '@/utils/request'
import GlobalHead from '@/views/layout/globalHead.vue'
// import GlobalFoot from '@/views/layout/globalFood.vue'
import LeftSider from './components/leftSider.vue'
import LeftSiderOneThing from './components/LeftSiderOneThing.vue'
import IconDelete from '@ant-design/icons/svg/outline/delete.svg?inline'
import IconCaretDown from '@ant-design/icons/svg/outline/caret-down.svg?inline'
import IconFileText from '@ant-design/icons/svg/outline/file-text.svg?inline'
import IconRunTime from './run-time.svg?inline'
import { jiopWebAPI } from '@/api/jiopweb/jiopweb'
import { jiopAPI } from '@/api/jiopweb/jiop'
import { timeTransfer } from '@/utils/timeUtil'
import { sm2 } from 'sm-crypto'
import { Ellipsis } from 'jpaas-component'
import Label from './components/Label.vue'
import SingleEventServices from './components/SingleEventServices.vue'
import AreaModal from '@/views/layout/AreaModal.vue'
const mockData3 = [
  {
    iid: 0,
    subjectName: '全部',
    isActive: true
  },
  {
    iid: 1,
    subjectName: '行政许可',
    isActive: false
  },
  {
    iid: 2,
    subjectName: '行政给付',
    isActive: false
  },
  {
    iid: 3,
    subjectName: '行政奖励',
    isActive: false
  },
  {
    iid: 4,
    subjectName: '行政确认',
    isActive: false
  },
  {
    iid: 5,
    subjectName: ' 行政裁决',
    isActive: false
  },
  {
    iid: 6,
    subjectName: '公共服务 ',
    isActive: false
  },
  {
    iid: 7,
    subjectName: '其他',
    isActive: false
  },
  {
    iid: 8,
    subjectName: '其他2',
    isActive: false
  },
  {
    iid: 9,
    subjectName: '其他3',
    isActive: false
  },
  {
    iid: 10,
    subjectName: '其他4',
    isActive: false
  },
  {
    iid: 11,
    subjectName: '其他5',
    isActive: false
  },
  {
    iid: 12,
    subjectName: '其他6',
    isActive: false
  }
]
const listData = [
  {
    title: '中外合作开办学期教育机构审批',
    tagList: [
      {
        iid: 0,
        name: '退役军人'
      },
      {
        iid: 1,
        name: '老年人'
      }
    ],
    content: '宣武区退役军人部'
  },
  {
    title: '学前教育机构设立｜（信用承诺）',
    tagList: [
      {
        iid: 0,
        name: '退役军人'
      },
      {
        iid: 1,
        name: '老年人'
      }
    ],
    content: '宣武区退役军人部'
  },
  {
    title:
      '自主就业退役士兵一次性经济补助给付（义务兵）自主就业退役士兵一次性经济补助给付（义务兵）自主就业退役士兵一次性经济补助给付（义务兵）',
    tagList: [],
    content: '宣武区退役军人部'
  }
]
export default {
  name: 'SingleEventList',
  components: {
    GlobalHead,
    // GlobalFoot,
    LeftSider,
    LeftSiderOneThing,
    Ellipsis,
    Label,
    SingleEventServices,
    AreaModal
  },
  filters: {
    timeTransfer
  },
  data () {
    return {
      userId: this.$store.getters.userId,
      labelType: 'hot',
      itemTotal: 0,
      IconDelete,
      IconCaretDown,
      IconFileText,
      IconRunTime,
      mockData: [],
      mockData2: [],
      mockData3,
      listData,
      selectData1: [],
      selectData2: [],
      selectData3: [],
      moreVis1: false,
      moreVis2: false,
      moreVis3: false,
      pagination: {
        total: 150,
        current: 1,
        pageSize: 10
      },
      queryParams: {
        appointCheck: false,
        onLineCheck: false
      },
      matterListAll: {},
      // 存放公共头部传入的参数
      globalData: [],
      districtId: '',
      groupId: '',
      // 区划部门数据
      selectDis: {},
      matterList: [],
      selectDataStr1: '',
      selectDataStr2: '',
      selectDataStr3: '',
      topServiceObj: sessionStorage.getItem('JiopSelectItem') || 'personal',
      visible: false,
      handling: { ctime: '' },
      metaStyle: {},
      draftVisible: false,
      swiperList: [],
      itemInfoBean: {},
      serviceObjectName: '',
      reportConfigByIid: {},
      itemId: '',
      middleData: [],
      prikey: '5506c31374d5d8e9d79ba5ecc7cd1a7d60df3f7ef5fbb6865ccd9ce489751ac7',
      videoUrl: 'https://nwmh.hanweb.com/jmeeting-web/#/createMeet',
      bannerType: 'personal',
      personOneThing: true,
      districtName: '',
      districtLabel: [],
      oneThingCount: undefined,
      checkedCardId: '',
      oneThingList: {},
      oneThingTheme: [],
      handleType: 'item',
      materialList: []
      // first: true // 允许按头部缓存跳转，1秒前不允许因为要根据路由跳转
    }
  },
  watch: {
    selectData1: {
      deep: true,
      immediate: true,
      handler: function (newVal, oldVal) {
        if (newVal.length > 0) {
          let str = []
          str = newVal.map(item => {
            return item.iid
          })
          this.selectDataStr1 = str.join(',')
          this.getMatterList()
        } else {
          this.selectDataStr1 = ''
          this.mockData.map((item, index) => {
            if (item.iid === 0) {
              item.isActive = true
            } else {
              item.isActive = false
            }
          })
          // this.getMatterList()
        }
      }
    },
    selectData2: {
      deep: true,
      immediate: true,
      handler: function (newVal, oldVal) {
        if (newVal.length > 0) {
          let str = []
          str = newVal.map(item => {
            return item.iid
          })
          this.selectDataStr2 = str.join(',')
          this.getMatterList()
        } else {
          this.selectDataStr2 = ''
          this.mockData2.map((item, index) => {
            if (item.iid === 0) {
              item.isActive = true
            } else {
              item.isActive = false
            }
          })
          // this.getMatterList()
        }
      }
    },
    selectData3: {
      deep: true,
      immediate: true,
      handler: function (newVal, oldVal) {
        if (newVal.length > 0) {
          let str = []
          str = newVal.map(item => {
            return item.iid
          })
          this.selectDataStr3 = str.join(',')
          this.getMatterList()
        } else {
          this.selectDataStr3 = ''
          this.mockData3.map((item, index) => {
            if (item.iid === 0) {
              item.isActive = true
            } else {
              item.isActive = false
            }
          })
          // this.getMatterList()
        }
      }
    }
    // 'itemInfoBean.taskServiceObj': {
    //   deep: true,
    //   immediate: true,
    //   handler: function (newVal, oldVal) {
    //     if (newVal) {
    //       this.findOptionList('materialNecessity,serviceObject,consultationMethod,complaintMethod,materialType,materialForm,sourceChannels')
    //     }
    //   }
    // }
    // mockData: {
    //   deep: true,
    //   immediate: true,
    //   handler: function (newVal, oldVal) {
    //   }
    // }
  },
  computed: {
    routerKey () {
      return this.$route.path
    }
  },
  created () {
    document.title = '事项列表'
    if (this.$route.query.bannerType) {
      this.bannerType = this.$route.query.bannerType
      this.topServiceObj = this.$route.query.bannerType
    }
    if (this.bannerType === 'oneThing') {
      this.labelType = 2
    }
    // 三个标签数据
    // const serviceObj = sessionStorage.getItem('JiopSelectItem')
    // const serviceObj = 'personal'
    // const serviceObj = 'legalperson'
    // let serviceObj = 'personal'
    // if (sessionStorage.getItem('JiopSelectItem') !== null) {
    //   serviceObj = sessionStorage.getItem('JiopSelectItem')
    // }
    // const array = []
    // jiopWebAPI.itemThemeList({ serviceObj: this.topServiceObj }).then(res => {
    //   if (res.success) {
    //     this.matterListAll = res.data.subjectList || {}
    //     this.swiperList = res.data.subjectList && res.data.subjectList.feature || []
    //     // 把该数据作为四个一组作为渲染 一维数组变为二维数组
    //     if (this.swiperList.length > 4) {
    //       for (let i = 0; i < this.swiperList.length; i += 4) {
    //         array.push(this.swiperList.slice(i, i + 4))
    //       }
    //     } else {
    //       array.push(this.swiperList)
    //     }
    //     this.middleData = JSON.parse(JSON.stringify(array))
    //     this.mockData = this.matterListAll.groups || []
    //     this.mockData.unshift({ iid: 0, subjectName: '全部' })
    //     this.mockData.map((item, index) => {
    //       if (item.iid === 0) {
    //         item.isActive = true
    //       } else {
    //         item.isActive = false
    //       }
    //     })
    //     this.mockData2 = this.matterListAll.theme || []
    //     this.mockData2.unshift({ iid: 0, subjectName: '全部' })
    //     this.mockData2.map((item, index) => {
    //       if (item.iid === 0) {
    //         item.isActive = true
    //       } else {
    //         item.isActive = false
    //       }
    //     })
    //     this.mockData3 = res.data.itemType.itemType || []
    //     this.mockData3 = this.mockData3.map(item => {
    //       return { iid: item.dictionaryCode, subjectName: item.name }
    //     })
    //     this.mockData3.unshift({ iid: 0, subjectName: '全部' })
    //     this.mockData3.map((item, index) => {
    //       if (item.iid === 0) {
    //         item.isActive = true
    //       } else {
    //         item.isActive = false
    //       }
    //     })
    //   }
    // })
  },
  methods: {
    getCookieData (cookieName) {
      try {
        var name = cookieName + '='
        var cookieMsg = document.cookie.replace(/%/g, '%25')
        var decodedCookie = decodeURIComponent(cookieMsg)
        var cookieArray = decodedCookie.split(';')
        for (var i = 0; i < cookieArray.length; i++) {
          var cookie = cookieArray[i]
          while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1)
          }
          if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length)
          }
        }
        return ''
      } catch (err) {
        console.log(err, 'cookieErr')
      }
    },
    // 切换标签状态
    changeLabelType (type) {
      if (type) {
        this.labelType = type
      }
      console.log('labelType', this.labelType)
      if (type === 'hot') {
        this.$refs.label.init()
      } else {
        this.$refs.singleEventServices.currentTag = '0'
        this.$refs.singleEventServices.getServiceList()
      }
    },
    videoHelp (itemName) {
      if (this.identityCheck(itemName)) {
        jiopWebAPI.getCurrentJis().then(res => {
          if (res.success) {
            const mobile = res.data.jisUserBean?.mobile
            const name = res.data.jisUserBean?.name
            const openUrl = this.videoUrl + '?mobile=' + mobile + '&userName=' + name
            console.log('+++++++++' + openUrl)
            window.location.href = openUrl
          }
        })
      }
    },
    transferredTime (json) {
      if (json != null) {
        return JSON.parse(json)
      } else {
        return 0
      }
    },
    toOneThingGuide (value, name, itt, showRobot) {
      sessionStorage.setItem('matter_name', itt.oneThingName)
      const url = this.$router.resolve({
        path: '/oneThingGuide',
        query: { itemId: value, subjectName: name, showRobot }
      })
      window.open(url.href, '_blank')
    },
    mouseLeaveBtn (e) {
      e.currentTarget.className = 'btnStyle-btn'
    },
    mouseOverBtn (e) {
      e.currentTarget.className = 'btnStyle-btn-active'
    },
    mouseLeave (e) {
      e.currentTarget.className = 'card-content'
    },
    mouseOver (e) {
      e.currentTarget.className = 'card-content-active'
    },
    changeOneThing (val) {
      console.log('changeOneThing', val)
      if (val === 'personal') {
        this.personOneThing = true
      } else {
        this.personOneThing = false
      }
      this.$refs.leftSiderOneThing.oneThingServiceOb = val
      this.$refs.leftSiderOneThing.loadSubject()
      console.log('1', val)
      this.getOneThingList()
    },
    updateGroup (value, label) {
      console.log('updateGroup', value, label, this.labelType)
      this.districtId = value
      this.districtLabel = label
      // if (
      //   this.$route.query.bannerType === 'personal' ||
      //   this.$route.query.bannerType === 'legalperson'
      // ) {
      //   this.$refs.leftSider.onSelect(value, label)
      //   if (this.$route.query.labelId) {
      //     this.$refs.label.init(this.$route.query.labelId)
      //   } else {
      //     this.$refs.label.init()
      //   }
      // } else {
      //   this.districtName = label[0]
      //   sessionStorage.setItem('districtId', value)
      //   this.getOneThingList()
      // }

      if (this.labelType === 'hot') {
        this.$refs.label.init(this.$route.query.labelId)
        // this.changeLabelType(this.labelType)
      } else {
        this.changeLabelType(this.labelType)
      }
    },
    getFilterList () {
      this.selectData1 = []
      this.selectData2 = []
      this.selectData3 = []
      this.selectDataStr1 = ''
      this.selectDataStr2 = ''
      this.selectDataStr3 = ''
      const array = []
      jiopWebAPI.itemThemeList({ serviceObj: this.topServiceObj, districtId: this.$route.query.areaCode || sessionStorage.getItem('districtId') }).then(res => {
        if (res.success) {
          this.swiperList = (res.data.subjectList && res.data.subjectList.feature) || []
          if (this.swiperList.length > 4) {
            for (let i = 0; i < this.swiperList.length; i += 4) {
              array.push(this.swiperList.slice(i, i + 4))
            }
          } else {
            array.push(this.swiperList)
          }
          this.middleData = JSON.parse(JSON.stringify(array))
          this.matterListAll = res.data.subjectList || {}
          console.log(this.matterListAll, 'matterListAll')
          this.mockData = this.matterListAll.groups || []
          this.mockData.unshift({ iid: 0, subjectName: '全部群体' })
          this.mockData.map((item, index) => {
            if (item.iid === 0) {
              item.isActive = true
            } else {
              item.isActive = false
            }
          })
          this.mockData2 = this.matterListAll.theme || []
          this.mockData2.unshift({ iid: 0, subjectName: '全部主题' })
          this.mockData2.map((item, index) => {
            if (index === 0) {
              item.isActive = true
              this.selectDataStr2 = item.iid
            } else {
              item.isActive = false
            }
          })
          this.mockData3 = res.data.itemType.itemType || []
          this.mockData3 = this.mockData3.map(item => {
            return { iid: item.dictionaryCode, subjectName: item.name }
          })
          this.mockData3.unshift({ iid: 0, subjectName: '全部类型' })
          this.mockData3.map((item, index) => {
            if (item.iid === 0) {
              item.isActive = true
            } else {
              item.isActive = false
            }
          })
        }
      })
    },
    // 通过子传父传过来的区划id和部门id
    getselectDis (value) {
      console.log('====value.====')
      this.selectDis = value
      this.getMatterList('true')
    },
    // 事项列表
    getMatterList (flag) {
      if (this.selectDis.districtId != null && this.selectDis.groupId != null) {
        this.pagination.current = flag === 'true' ? 1 : this.pagination.current
        jiopAPI
          .findMatterList({
            applicableGroupIds: this.selectDataStr1,
            themeIds: this.selectDataStr2 === 0 ? '' : this.selectDataStr2,
            itemTypeIds: this.selectDataStr3,
            taskServiceObj: this.topServiceObj,
            districtId: this.selectDis.districtId,
            groupId: this.selectDis.groupId,
            pageNo: this.pagination.current,
            pageSize: this.pagination.pageSize,
            publishrange: 'pc'
          })
          .then(res => {
            if (res.success) {
              this.matterList = res.data.matterList || []
              this.pagination.total = res.data.total
              this.itemTotal = res.data.total
            }
          })
      }
    },
    // 特色分类页面
    golocalFeature (iid, subjectName) {
      console.log('=====特色页面')
      const url = this.$router.resolve({
        path: '/localFeature',
        query: { itemType: this.topServiceObj, subjectId: iid, subjectName: subjectName }
      })
      window.open(url.href, '_blank')
    },
    loadmenuData (menuData) {
      const that = this
      that.oneThingTheme = menuData
      that.getOneThingList()
    },
    reLoadRight (themeIds) {
      this.getOneThingList(themeIds)
    },
    // 加载一件事
    getOneThingList (themeIds) {
      const that = this
      console.log('district====' + this.$route.query.areaCode)
      jiopWebAPI
        .findOneThingMatter({
          districtCode: this.$route.query.areaCode,
          serviceObj: this.personOneThing ? 'personal' : 'legalperson',
          themeIds: themeIds || ''
        })
        .then(res => {
          if (res.success) {
            that.oneThingList = res.data.result
            that.oneThingCount = res.data.totalCount
            // that.$refs.leftSiderOneThing.oneThingList = that.oneThingList
            // 获取右侧一件事长度
            // that.$refs.leftSiderOneThing.maxHeight = that.$refs.rightSideOneThing.offsetHeight
          }
        })
    },
    // 获取公共头部传入的参数，根据参数获取页面展示数据
    updateData (val, district) {
      // this.bannerType = val[0]
      console.log('val', val)
      this.globalData = val
      if (val[0] === 'oneThing') {
      } else {
        if (this.globalData.length > 0) {
          this.pagination.current = 1
          // this.topServiceObj = this.globalData[0]
          if (this.selectDis) {
            this.getMatterList()
          }
          this.getFilterList()
          // 更新左侧机构树
          setTimeout(() => {
            this.$refs.leftSider.getGroupList()
          }, 100)
        }
      }
    },
    // 去简单办事指南
    toPublic (value, guidePcSite, showRobot) {
      const url = this.$router.resolve({
        path: '/guideSimple',
        query: {
          itemId: value,
          areaCode: this.$route.query.areaCode,
          bannerType: this.$route.query.bannerType,
          showRobot
        }
      })
      if (guidePcSite) {
        window.open(guidePcSite, '_blank')
      } else {
        window.open(url.href, '_blank')
      }
    },
    // 获取matter数据并存入缓存
    getItemBeanSimple (iid, type) {
      this.handleType = type
      if (type === 'onething') {
        jiopAPI.oneThingGuide({ iid: iid }).then(res => {
          if (res.success) {
            if (res.data.oneThings && res.data.reportConfigByIid) {
              this.itemInfoBean = res.data.oneThings || {}
              this.reportConfigByIid = res.data.reportConfigByIid
              this.findOptionList(
                'materialNecessity,serviceObject,consultationMethod,complaintMethod,materialType,materialForm,sourceChannels',
                type
              )
            }
          }
        })
      } else {
        jiopAPI.findItemBeanSimple({ itemId: iid }).then(res => {
          if (res.success) {
            if (res.data.itemInfoBean && res.data.reportConfigByIid) {
              this.itemInfoBean = res.data.itemInfoBean || {}
              this.reportConfigByIid = res.data.reportConfigByIid
              this.findOptionList(
                'materialNecessity,serviceObject,consultationMethod,complaintMethod,materialType,materialForm,sourceChannels',
                type
              )
            }
          }
        })
      }
    },
    setMatterSession (itemInfoBean, reportConfigByIid, itemId, type) {
      console.log(itemInfoBean)
      const obj = {}
      obj.tag = this.serviceObjectName
      obj.groupName = itemInfoBean.deptName
      if (type === 'onething') {
        obj.applyName = itemInfoBean.oneThingName
        obj.matterName = itemInfoBean.oneThingName
      } else {
        obj.applyName = itemInfoBean.itemName
        obj.matterName = itemInfoBean.itemName
      }
      obj.applySource = 'PC'
      obj.matterId = itemInfoBean.iid
      obj.taskCode = itemInfoBean.taskCode
      obj.code = '11'
      obj.flowId = reportConfigByIid.flowId
      obj.metaId = reportConfigByIid.metaId
      obj.itemType = 'onething'
      const matter = JSON.stringify(obj)
      sessionStorage.setItem(itemId + '_matter', matter)
    },
    getSteps (iid) {
      jiopWebAPI.findReportConfigByIid({ itemid: iid }).then(res => {
        const fillingInstruction = res.data.data.fillingInstruction
        const situation = res.data.data.situation
        const formConfig = res.data.data.formConfig
        const uploadMaterial = res.data.data.uploadMaterial
        const pickupMethod = res.data.data.pickupMethod
        const inforMationConfirmed = res.data.data.inforMationConfirmed
        sessionStorage.setItem(
          iid + '_fill',
          JSON.stringify({
            userAgreeMentName: res.data.data.userAgreeMentName,
            userAgreementContent: res.data.data.userAgreementContent
          })
        )
        let total = 0
        if (fillingInstruction === 'on') {
          total++
        }
        if (situation === 'on') {
          total++
        }
        if (formConfig === 'on') {
          total++
        }
        if (uploadMaterial === 'on') {
          total++
        }
        if (pickupMethod === 'on') {
          total++
        }
        if (inforMationConfirmed === 'on') {
          total++
        }
        const handleType = this.handleType === 'item' ? 'item' : 'onething'
        if (fillingInstruction === 'on') {
          const url = this.$router.resolve({
            path: '/fillInstruction',
            query: {
              itemId: this.itemId,
              stepNo: 0,
              total: total,
              flowId: res.data.data.flowId,
              handleType: handleType,
              bannerType: this.$route.query.bannerType
            }
          })
          window.open(url.href, '_blank')
        } else if (situation === 'on') {
          const url = this.$router.resolve({
            path: '/selectSitution',
            query: {
              itemId: this.itemId,
              stepNo: 0,
              total: total,
              flowId: res.data.data.flowId,
              handleType: handleType,
              bannerType: this.$route.query.bannerType
            }
          })
          window.open(url.href, '_blank')
        } else if (formConfig === 'on') {
          const url = this.$router.resolve({
            path: '/matterForm',
            query: {
              itemId: this.itemId,
              stepNo: 0,
              total: total,
              flowId: res.data.data.flowId,
              handleType: handleType,
              bannerType: this.$route.query.bannerType
            }
          })
          window.open(url.href, '_blank')
        } else if (uploadMaterial === 'on') {
          const url = this.$router.resolve({
            path: '/uploadMaterial',
            query: {
              itemId: this.itemId,
              stepNo: 0,
              total: total,
              flowId: res.data.data.flowId,
              handleType: handleType,
              bannerType: this.$route.query.bannerType
            }
          })
          window.open(url.href, '_blank')
        } else if (pickupMethod === 'on') {
          const url = this.$router.resolve({
            path: '/receiveInfo',
            query: {
              itemId: this.itemId,
              stepNo: 0,
              total: total,
              flowId: res.data.data.flowId,
              handleType: handleType,
              bannerType: this.$route.query.bannerType
            }
          })
          window.open(url.href, '_blank')
        } else if (inforMationConfirmed === 'on') {
          const url = this.$router.resolve({
            path: '/confirmInfo',
            query: {
              itemId: this.itemId,
              stepNo: 0,
              total: total,
              flowId: res.data.data.flowId,
              handleType: handleType
            }
          })
          window.open(url.href, '_blank')
        }
      })
    },
    // 清除session
    cleanSession () {
      sessionStorage.removeItem(this.itemId + '_listOfSituations')
      sessionStorage.removeItem(this.itemId + '_model')
      sessionStorage.removeItem(this.itemId + '_infoStr')
      sessionStorage.removeItem(this.itemId + '_JiopwebReceive')
      sessionStorage.removeItem(this.itemId + '_JiopwebMaterial')
      // 清空智能填报缓存
      sessionStorage.removeItem(this.itemId + 'SmartFill')
    },
    getDraft (iid) {
      this.cleanSession()
      const that = this
      const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
      const userParams = JSON.parse(userInfo.desensitizeUser)
      const userId = userParams.uid
      jiopWebAPI.queryDraft({ userId: userId, matterId: iid }).then(res => {
        if (res.success) {
          if (res.data.draft.handling && res.data.draft.metaStyle) {
            const jsonHandling = sm2.doDecrypt(res.data.draft.handling.substring(2), that.prikey, 1)
            const jsonMetaStyle = sm2.doDecrypt(
              res.data.draft.metaStyle.substring(2),
              that.prikey,
              1
            )
            that.handling = JSON.parse(jsonHandling)
            that.metaStyle = JSON.parse(jsonMetaStyle)
            that.draftVisible = true
            // that.routingHop(iid)
            that.materialList = res.data.draft.itemMaterialList || []
          } else {
            that.routingHop(iid)
          }
        }
      })
    },
    routingHop (iid) {
      this.getSteps(iid)
    },
    setSessionData () {
      if (this.handling.situationSelect) {
        // 存入情形
        sessionStorage.setItem(this.itemId + '_listOfSituations', this.handling.situationSelect)
      }
      if (this.handling.model && this.metaStyle.formData) {
        // 存入表单
        sessionStorage.setItem(this.itemId + '_model', this.handling.model)
        sessionStorage.setItem(this.itemId + '_infoStr', this.metaStyle.formData)
      }
      // 存入上传材料(当上传材料发生改变时，后台清除已上传的材料，不需要前端比对)
      if (this.metaStyle && this.metaStyle.uploadMaterial) {
        sessionStorage.setItem(this.itemId + '_JiopwebMaterial', this.metaStyle.uploadMaterial)
      }
      if (parseInt(this.handling.receiveType) === 0 || parseInt(this.handling.receiveType) === 1) {
        // 存入取件方式
        const params = { receiveType: this.handling.receiveType }
        if (parseInt(this.handling.receiveType) === 1) {
          params.receiveUserName = this.handling.receiveUserName
          params.receivePhone = this.handling.receivePhone
          params.receiveDetailArea = this.handling.receiveDetailArea
          params.receiveArea = this.handling.receiveArea
        }
        sessionStorage.setItem(this.itemId + '_JiopwebReceive', JSON.stringify(params))
      }
    },
    // 继续编辑
    refill () {
      const that = this
      this.setSessionData()
      jiopWebAPI.findReportConfigByIid({ itemid: this.itemId }).then(res => {
        let total = 0
        const fillingInstruction = res.data.data.fillingInstruction
        const situation = res.data.data.situation
        const formConfig = res.data.data.formConfig
        const uploadMaterial = res.data.data.uploadMaterial
        const pickupMethod = res.data.data.pickupMethod
        const inforMationConfirmed = res.data.data.inforMationConfirmed
        const intelligentApproval = res.data.data.intelligentApproval ? res.data.data.intelligentApproval : 'off'
        const acceptFlowId = res.data.data.acceptFlowId
        const wholeIntelligentApproval = res.data.data.wholeIntelligentApproval ? res.data.data.wholeIntelligentApproval : 'off'
        const stepList = []
        if (fillingInstruction === 'on') {
          total++
          stepList.push({ name: 'fillInstruction', isOpen: false })
        }
        if (situation === 'on') {
          total++
          stepList.push({ name: 'selectSitution', isOpen: false })
        }
        if (formConfig === 'on') {
          total++
          stepList.push({ name: 'matterForm', isOpen: false })
        }
        if (uploadMaterial === 'on') {
          total++
          stepList.push({ name: 'uploadMaterial', isOpen: false })
        }
        if (pickupMethod === 'on') {
          total++
          stepList.push({ name: 'receiveInfo', isOpen: false })
        }
        if (inforMationConfirmed === 'on') {
          total++
          stepList.push({ name: 'confirmInfo', isOpen: false })
        }
        const stepNo = that.handling.steps
        const router = '/' + stepList[stepNo].name
        const handleType = this.handleType === 'item' ? 'item' : 'onething'
        that.$router.push({
          path: router,
          query: {
            itemId: that.itemId,
            stepNo: stepNo,
            total: total,
            flagTag: '0',
            flowId: res.data.data.flowId,
            handleType: handleType,
            materialList: JSON.stringify(that.materialList),
            intelligentApproval: intelligentApproval,
            acceptFlowId: acceptFlowId,
            wholeIntelligentApproval: wholeIntelligentApproval
          }
        })
      })
    },
    toGuide (iid, name, type, taskPcSite) {
      console.log('开始办理')
      if (process.env.NODE_ENV === 'development') {
        console.log('开发环境进来的')
        sessionStorage.setItem(
          'JiopUserInfo',
          JSON.stringify({
            isLogin: true,
            encodeUser: '0450b5963d2dd660cea0d33f9d96a932f5a19ccda3d22c9e64da0ea187e56e6250e5f1f927be4a638fd73f2fee9b77c10f8d9bb3c0d736167203f4eb9c4dbd06a9018284e7ae7b50bc270fe9acb80303b7c7a075dccbe616addbd94a706217e3bbfaf5d8ed1aa8b26b04965b371402a78ee3a09ed9ed6c421a6fcc4c70c04fe5096967e9a85b068ef1b7b33472c23814e25dc4d0d8d16e7b77a05afcbffb15f937ced74b03c60cd70ea4002e02774fc753195c8c568c9a3a9e07334004286bd8498df435495dd8bd47eca8f31ff884774af71fd9c9f376d0f2de58efa39f007d70f0310f36b1f09c6f04991764210b48c1e9b665db9fb6c2592d320b17f94fd2f5e988fa2eba5b677802798ee396ab3e928294aa750ee844e4756aededf38333ac80dc936398b3ab9229ecd5e0c031a98147c61e239c3760c455055fe7d89548a40e8b2aa4a433b4dd25211cadcccd6e75cb3f73297ffce06bd3dab1ee59ac3df2ad70',
            desensitizeUser:
              '{"uid":"ab91261e859e4038bc5302fe785f2363","userType":1,"name":"*若诗","mobile":"195******92","certType":"居民身份证","certNo":"2****************X","corporationName":null,"creditCode":null,"corUserName":null,"corUserCertType":null,"corUserCertNo":null}',
            accessToken:
              'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3MTYyNzI1MzEsImlhdCI6MTcxNjI3MDczMSwidXNlcm5hbWUiOiJhYjkxMjYxZTg1OWU0MDM4YmM1MzAyZmU3ODVmMjM2MyJ9.gwB9n_SD9YivfOFZsYo7z_cxIuZimpvsIBiBW9ejqqM'
            // 'access-token': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2OTQ0MTg4MTMsImlhdCI6MTY5NDQwMDgxMywidXNlcm5hbWUiOiIwMjIwZjU1ZGI2OWI0ZjI0OWU4YjY5YjgwYWZiOWQ5NSJ9.3tMTDJih83tyBFTKq4xn289VaLHFg8O-5JefwknEJZw'
          })
        )
        document.cookie =
          'accessToken=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3MTYyNzI1MzEsImlhdCI6MTcxNjI3MDczMSwidXNlcm5hbWUiOiJhYjkxMjYxZTg1OWU0MDM4YmM1MzAyZmU3ODVmMjM2MyJ9.gwB9n_SD9YivfOFZsYo7z_cxIuZimpvsIBiBW9ejqqM'
        sessionStorage.setItem('JiopSelectItem', 'personal')
        // axios.defaults.headers['access-token'] = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2OTQ0MTg4MTMsImlhdCI6MTY5NDQwMDgxMywidXNlcm5hbWUiOiIwMjIwZjU1ZGI2OWI0ZjI0OWU4YjY5YjgwYWZiOWQ5NSJ9.3tMTDJih83tyBFTKq4xn289VaLHFg8O-5JefwknEJZw'
        axios.defaults.headers['accessToken'] =
          'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3MTYyNzI1MzEsImlhdCI6MTcxNjI3MDczMSwidXNlcm5hbWUiOiJhYjkxMjYxZTg1OWU0MDM4YmM1MzAyZmU3ODVmMjM2MyJ9.gwB9n_SD9YivfOFZsYo7z_cxIuZimpvsIBiBW9ejqqM'
      }
      this.itemId = iid
      if (this.identityCheck(name)) {
        // 跳转到办事流程
        if (taskPcSite) {
          window.open(taskPcSite, '_blank')
        } else {
          this.getItemBeanSimple(iid, type)
        }
      }
    },
    findOptionList (paramter, type) {
      jiopAPI.findOption(Object.assign({ type: paramter })).then(res => {
        if (res.success) {
          if (res.data.data.serviceObject) {
            const objNameList = []
            const serviceObjList = this.itemInfoBean.taskServiceObj
              ? this.itemInfoBean.taskServiceObj.split(',')
              : []
            res.data.data.serviceObject.forEach(val => {
              serviceObjList.forEach(v => {
                if (v === val.dictionaryCode) {
                  objNameList.push(val.name)
                }
              })
            })
            this.serviceObjectName = objNameList.join('、')
            this.setMatterSession(this.itemInfoBean, this.reportConfigByIid, this.itemId, type)
            // 判断是否有草稿
            this.getDraft(this.itemId)
          }
        }
      })
    },
    checked (name) {
      if (sessionStorage.getItem('JiopUserInfo')) {
        console.log('获取到信息了')
        const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
        console.log('获取用户登录信息', userInfo)
        if (userInfo.isLogin) {
          const userParams = JSON.parse(userInfo.desensitizeUser)
          const userType =
              this.getCookieData('userType') === 1 || parseInt(userParams.userType) === 1
                ? 'personal'
                : 'legalperson'
          const seletType =
              this.$route.query.bannerType === 'oneThing'
                ? this.personOneThing
                  ? 'personal'
                  : 'legalperson'
                : this.$route.query.bannerType
          if (seletType !== userType) {
            const type =
              this.$route.query.bannerType === 'personal'
                ? '个人'
                : this.$route.query.bannerType === 'legalperson'
                  ? '法人'
                  : this.personOneThing
                    ? '个人'
                    : '法人'
            this.$info({
              title: `该事项仅限${type}账户办理`,
              content: (
                <div>
                  您不是{name}的服务对象
                  <br/>
                  请登录{type}账户再来吧
                </div>
              ),
              onCancel () {
              }
            })
            return false
          } else {
            return true
          }
        } else {
          // 是否登录提示框（未登录）
          console.log('未登录1')
          this.visible = true
          return false
        }
      } else {
        // 是否登录提示框（未登录）
        console.log('未登录2')
        this.visible = true
        return false
      }
    },
    // 校验是否登录，若已登录校验是个人还是法人，未登录去登录
    identityCheck (name) {
      console.log('获取用户信息', sessionStorage.getItem('JiopUserInfo'))
      if (!sessionStorage.getItem('JiopUserInfo')) {
        console.log('未获取到信息')
        jiopWebAPI
          .isLogin({ userType: 1, appType: 1 })
          .then(res => {
            if (res.success) {
              sessionStorage.setItem('JiopUserInfo', JSON.stringify(res.data))
              return this.checked(name)
            }
          })
      } else {
        return this.checked(name)
      }
    },
    handleOk () {
      this.visible = false
      this.toLoginPage()
    },
    handleCancel () {
      this.visible = false
    },
    toLoginPage () {
      const params = this.$route.query || {}
      params.jiopWorkUrl = 'jiopweb/' + this.$route.name
      jiopWebAPI.getLoginUrl({ params: JSON.stringify(params) }).then(res => {
        if (res.success) {
          if (res.data.url) {
            window.location.href = res.data.url
          }
        }
      })
    },
    appointChange (value) {
      this.queryParams.appointCheck = value.target.checked
    },
    onLineChange (value) {
      this.queryParams.onLineCheck = value.target.checked
    },
    pageChange (pageNo, pageSize) {
      this.pagination.current = pageNo
      this.pagination.pageSize = pageSize
      this.getMatterList()
    },
    selectLi (value, type) {
      if (type === 'type1') {
        // 针对全部按钮进行单独判断
        if (value.iid === 0) {
          if (!value.isActive) {
            this.selectData1 = []
            this.mockData = this.mockData.map(item => {
              if (item.iid !== 0) {
                item.isActive = false
              } else {
                item.isActive = true
              }
              return item
            })
          }
        } else {
          // 不是全部按钮的操作
          this.mockData = this.mockData.map(item => {
            if (item.iid === 0) {
              item.isActive = false
            }
            if (value.iid === item.iid) {
              if (item.isActive) {
                item.isActive = false
                this.selectData1 = this.selectData1.filter(li => {
                  if (li.iid === item.iid) {
                    return false
                  } else {
                    return true
                  }
                })
              } else {
                item.isActive = true
                // 只能选中一个
                this.mockData.forEach(obj => {
                  if (obj.iid !== item.iid) {
                    obj.isActive = false
                  }
                })
                // this.selectData1.push(value)
                this.selectData1 = [value]
              }
            }
            return item
          })
        }
        if (this.selectData1.length === 0) {
          this.selectDataStr1 = ''
          this.getMatterList()
        }
      }
      if (type === 'type2') {
        if (value.iid === 0) {
          if (!value.isActive) {
            this.selectData2 = []
            this.mockData2 = this.mockData2.map(item => {
              if (item.iid !== 0) {
                item.isActive = false
              } else {
                item.isActive = true
              }
              return item
            })
          }
        } else {
          // 不是全部按钮的操作
          this.mockData2 = this.mockData2.map(item => {
            if (item.iid === 0) {
              item.isActive = false
            }
            if (value.iid === item.iid) {
              if (item.isActive) {
                item.isActive = false
                this.selectData2 = this.selectData2.filter(li => {
                  if (li.iid === item.iid) {
                    return false
                  } else {
                    return true
                  }
                })
              } else {
                item.isActive = true
                // 只能选中一个
                this.mockData2.forEach(obj => {
                  if (obj.iid !== item.iid) {
                    obj.isActive = false
                  }
                })
                // this.selectData2.push(value)
                this.selectData2 = [value]
              }
            }
            return item
          })
        }
        if (this.selectData2.length === 0) {
          this.selectDataStr2 = ''
          this.getMatterList()
        }
      }
      if (type === 'type3') {
        if (value.iid === 0) {
          if (!value.isActive) {
            this.selectData3 = []
            this.mockData3 = this.mockData3.map(item => {
              if (item.iid !== 0) {
                item.isActive = false
              } else {
                item.isActive = true
              }
              return item
            })
          }
          this.selectDataStr3 = ''
          this.getMatterList()
        } else {
          // 不是全部按钮的操作
          this.mockData3 = this.mockData3.map(item => {
            if (item.iid === 0) {
              item.isActive = false
            }
            if (value.iid === item.iid) {
              if (item.isActive) {
                item.isActive = false
                this.selectData3 = this.selectData3.filter(li => {
                  if (li.iid === item.iid) {
                    return false
                  } else {
                    return true
                  }
                })
              } else {
                item.isActive = true
                // 只能选中一个
                this.mockData3.forEach(obj => {
                  if (obj.iid !== item.iid) {
                    obj.isActive = false
                  }
                })
                // this.selectData3.push(value)
                this.selectData3 = [value]
              }
            }
            return item
          })
        }
        if (this.selectData3.length === 0) {
          this.selectDataStr3 = ''
          this.getMatterList()
        }
      }
    },
    tagClose (type, value) {
      if (type === 'type1') {
        this.selectData1 = this.selectData1.filter(item => {
          if (item.iid === value.iid) {
            return false
          } else {
            return true
          }
        })
        this.mockData = this.mockData.map(item => {
          if (value.iid === item.iid) {
            item.isActive = false
          }
          return item
        })
        if (this.selectData1.length === 0) {
          this.selectDataStr1 = ''
          this.getMatterList()
        }
      }
      if (type === 'type2') {
        this.selectData2 = this.selectData2.filter(item => {
          if (item.iid === value.iid) {
            return false
          } else {
            return true
          }
        })
        this.mockData2 = this.mockData2.map(item => {
          if (value.iid === item.iid) {
            item.isActive = false
          }
          return item
        })
        if (this.selectData2.length === 0) {
          this.selectDataStr2 = ''
          this.getMatterList()
        }
      }
      if (type === 'type3') {
        this.selectData3 = this.selectData3.filter(item => {
          if (item.iid === value.iid) {
            return false
          } else {
            return true
          }
        })
        this.mockData3 = this.mockData3.map(item => {
          if (value.iid === item.iid) {
            item.isActive = false
          }
          return item
        })
        if (this.selectData3.length === 0) {
          this.selectDataStr3 = ''
          this.getMatterList()
        }
      }
    },
    allDelete () {
      this.selectData1 = []
      this.selectData2 = []
      this.selectData3 = []
      this.selectDataStr1 = ''
      this.selectDataStr2 = ''
      this.selectDataStr3 = ''
      this.mockData = this.mockData.map(item => {
        if (item.iid === 0) {
          item.isActive = true
        } else {
          item.isActive = false
        }
        return item
      })
      this.mockData2 = this.mockData2.map(item => {
        if (item.iid === 0) {
          item.isActive = true
        } else {
          item.isActive = false
        }
        return item
      })
      this.mockData3 = this.mockData3.map(item => {
        if (item.iid === 0) {
          item.isActive = true
        } else {
          item.isActive = false
        }
        return item
      })
      this.getMatterList()
    },
    moreClick (type, value) {
      if (type === 'type1') {
        this.moreVis1 = value
      }
      if (type === 'type2') {
        this.moreVis2 = value
      }
      if (type === 'type3') {
        this.moreVis3 = value
      }
    }
  }
}
</script>

<style lang="less" scoped>
.one-thing-text-active {
  width: 120px;
  height: 33px;

  font-size: 24px;
  color: #000000;
  text-align: center;
  font-weight: 500;
}
.one-thing-text {
  width: 120px;
  height: 33px;

  font-size: 24px;
  color: #ffffff;
  text-align: center;
  font-weight: 500;
}
.one-thing-div-active {
  width: 320px;
  height: 70px;
  background: #ffffff;
  text-align: center;
  padding-top: 15px;
  cursor: pointer;
}
.one-thing-div {
  width: 320px;
  height: 70px;
  background: rgba(153, 153, 153, 0.2);
  text-align: center;
  padding-top: 15px;
  cursor: pointer;
}
.topBanner {
  width: 100%;
  height: 200px;
  margin-bottom: 30px;
  background: url(./banner.png) repeat-y;
}
::v-deep .ant-carousel .slick-dots li.slick-active button {
  background: url('~@/assets/jiopweb3.0.0/lunboSelect.png');
  width: 32px;
  height: 10px;
  margin: 0 5px;
}
::v-deep .ant-carousel .slick-dots li button {
  background: url('~@/assets/jiopweb3.0.0/lunboActive.png');
  width: 8px;
  opacity: 1;
  height: 8px;
}
.active {
  background: #1677ff;
  color: #fff !important;
  padding: 2px 8px;
  border-radius: 3px;
}
.card-content-right-text {
  width: 56px;
  height: 20px;

  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 500;
}
.new-div-text {
  width: 23px;
  height: 20px;

  font-size: 14px;
  color: #1677ff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
}
.new-div {
  width: 80px;
  height: 24px;
  background: #e1ebff;
  padding-top: 1px;
  margin-left: 2px;
}
.old-div-text {
  width: 23px;
  height: 20px;

  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  font-weight: 500;
}
.old-div {
  width: 80px;
  height: 24px;
  background: #efefef;
  padding-top: 1px;
}
.card-content-right-old {
  width: 42px;
  height: 20px;

  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
}
.card-content-right-now {
  width: 42px;
  height: 20px;

  font-size: 14px;
  color: #1677ff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
}
.btnStyle-btn-active {
  height: 40px;
  width: 92px;
  // margin-right: 9px;
  padding: 8px 16px;
  border: 1px solid rgba(22, 119, 255, 1);
  border-radius: 2px;
  cursor: pointer;
  font-size: 14px;
  color: #fff;
  background: rgba(22, 119, 255, 1);
}
.btnStyle-btn {
  height: 40px;
  width: 92px;
  // margin-right: 9px;
  padding: 8px 16px;
  border: 1px solid rgba(22, 119, 255, 1);
  border-radius: 2px;
  cursor: pointer;
  font-size: 14px;
  color: #1777ff;
}

.rightSideOneThing {
  float: right;
  margin-right: 29px;
  margin-top: 12px;
  width: 75%;
  min-height: 800px;
  margin-bottom: 30px;
  // border: 1px solid #999999;
  box-shadow: 0px 0px 15px 0px rgba(153, 153, 153, 0.2);
}
.rightSide {
  float: right;
  width: 77%;
  min-height: 800px;
  .rightSideTop {
    padding: 25px 0 20px 0;
    width: 100%;
    border: 1px solid rgba(238, 238, 238, 1);
    .allselect {
      padding-left: 60px;
      margin-top: 20px;
      .title {
        // display: flex;
        position: relative;
        margin-right: 18px;
        font-size: 14px;
        color: #1777ff;
        .GlobalHeadBox {
          display: inline-block;
          background: red;
          // position: absolute;
          // top: 40px;
          // left: 50px;
        }
      }
    }
    .liRow {
      margin-bottom: 0px;
      padding: 0 30px;
      overflow: hidden;
      align-items: center;
      flex-wrap: nowrap;
      .title {
        float: left;
        margin-top: 9px;
        margin-right: 20px;
        height: 24px;
        font-size: 14px;
        color: #999999;
        line-height: 24px;
        width: 56px;
        font-weight: 400;
        margin-bottom: 9px;
      }
      .liContent {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        margin-top: 9px;
        .liContentTag {
          display: inline-block;
          // margin-top: -5px;
          width: 86px;
          // line-height: 38px;
          .tagCont {
            cursor: pointer;
            color: #333333;
            padding: 2px 4px;
            font-size: 14px;
            display: inline-block;
            height: 28px;
            width: 77px;
            padding-left: 10px;
            line-height: 24px;
            margin-top: -2px;
          }
        }
      }
      // .liContent .liContentTag:first-child {
      //   width: 46px;
      // }
    }
  }
  .rightSideBot {
    border: 1px solid #eee;
    margin-top: 20px;
    padding: 0 30px;
    .header {
      border-bottom: 1px solid #eee;
      height: 50px;
      line-height: 50px;
    }
    .contentList {
      .liStyle {
        overflow: hidden;
        height: 75px;
        border-bottom: 1px solid #eee;
        .liLeft {
          width: 70%;
          float: left;
          padding-top: 15px;
          .title {
            display: inline-block;
            width: 99%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            font-size: 16px;
            color: #333333;
            font-weight: bold;
          }
        }
        .rightLeft {
          float: right;
          margin-top: 22px;
          .btnStyle {
            height: 32px;
            width: 88px;
            margin-right: 20px;
            padding: 5px 16px;
            border: 1px solid rgba(23, 119, 255, 1);
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
            color: #1777ff;
          }
          .btnFalseStyle {
            height: 32px;
            width: 88px;
            margin-right: 20px;
            padding: 5px 16px;
            border: 1px solid #888;
            border-radius: 4px;
            font-size: 14px;
            color: #888;
          }
          .btn {
            border: none;
            background-color: rgba(24, 144, 255, 0.1);
            color: #1777ff;
          }
        }
      }
    }
  }
}
.tagContTemp {
  margin-top: -14px;
  cursor: pointer;
  line-height: 38px;
  padding: 2px 4px;
  font-size: 14px;
  position: absolute;
  right: -5px;
  top: 6px;
}

.leftSider {
  margin-top: 9px;
  float: left;
}
.swiperBoxWrap {
  overflow: hidden;
  height: 200px;
  padding-top: 10px;
  display: flex;
}
.bannerTab {
  width: 100%;
  height: 240px;
  // opacity: 0.85;
  background: url(../../../assets/banner.png) 0 0 no-repeat;
  // 图片适应容器大小
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  .title {
    width: 1200px;
    line-height: 56px;
    margin-top: 61px;
    font-size: 40px;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: 600;
  }
  .tabs {
    display: flex;
    width: 1200px;
    height: 70px;
    // margin: 13px;
    .tab {
      width: 25%;
      line-height: 70px;
      text-align: center;
      font-weight: 500;
      font-size: 24px;
      cursor: pointer;
      margin: 0 5px;
      // 设置元素间隔，不包括最后一个元素和第一个元素
      &:last-child {
        margin-right: 0;
      }
      &:first-child {
        margin-left: 0;
      }
    }
    .bannerActive {
      color: #000000 !important;
      background: rgba(255, 255, 255, 1);
    }
    .bannerInactive {
      color: #ffffff !important;
      background: rgba(255, 255, 255, 0.2);
      // opacity: 0.2 !important;
    }
  }
}
.wrapper {
  width: 1240px;
  margin: auto;
  margin-top: 30px;
}
.ant-carousel ::v-deep .slick-slide {
  height: 240px;
  width: 100%;
}

.card-content-left-link {
  width: 154px;
  height: 28px;

  font-size: 14px;
  color: #1777ff;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 400;
  margin-top: 2px;
  margin-left: 16px;
}
.card-content-left-text {
  font-size: 14px;
  color: #666666;
  font-weight: 400;
}
.card-content-left-content {
  width: 100%;
  // height: 28px;
  letter-spacing: 0;
  line-height: 28px;
}
.card-content-left {
  float: left;
  width: 350px;
}
.card-content-right {
  float: left;
  width: 360px;
}
.card-content {
  margin: 0 auto;
  padding: 20px;
  width: 870px;
  height: 188px;
  background: #f7faff;
  margin-bottom: 20px;
}
.card-content-active {
  margin: 0 auto;
  padding: 18px;
  width: 870px;
  height: 188px;
  background: #f7faff;
  margin-bottom: 20px;
  border: 2px solid rgba(171, 206, 255, 1);
}
.card-content-left-title {
  width: 90px;
  height: 26px;

  font-size: 18px;
  color: #333333;
  letter-spacing: 0;
  line-height: 26px;
  font-weight: 500;
}
.card-content-right-action {
  float: right;
  //  padding-top:  56px;
  margin-right: 9px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .btn {
    font-size: 14px;
    color: #1677ff;
    font-weight: 400;
    margin-top: 20px;
  }
}
.subject-title {
  padding-left: 30px;
  padding-top: 9.2px;
  padding-bottom: 19px;
  width: 100%;

  font-size: 22px;
  color: #333333;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 500;
}
.right-title {
  width: 100%;

  font-size: 15px;
  color: #999999;
  font-weight: 400;
  padding: 14px;
  border-bottom: 1px solid #eeeeee;
  padding-left: 30px;
  margin-bottom: 22px;
}
.swiperBox {
  cursor: pointer;
  float: left;
  margin-left: 20px;
  width: 278px;
  height: 180px;
  background: #ffffff;
  box-shadow: 0px 2px 15px 0px rgba(153, 153, 153, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  img {
    width: 80px;
    height: 80px;
    margin-top: 20px;
  }
  .swiperContet {
    width: 100%;
    height: 60px;
    text-align: center;

    font-size: 18px;
    color: #333333;
    font-weight: bold;
    margin-top: 10px;
    overflow: hidden;
  }
}
</style>
